import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthData } from "../../../../redux/features/auth/authSlice.js";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import { Pagination, Skeleton, Typography } from "@mui/material";
import RowContainer from "../../../common/RowContainer.js";
import ColumnContainer from "../../../common/ColumnContainer.js";
import { TitleContainer, Wrapper } from "../../style.js";
import {
  changePageNumberTickets,
  getTicketsList,
} from "../../../../redux/features/tickets/ticketsSlice.js";
import ProjectsList from "./ProjectsList.js";
import { getProjects } from "../../../../redux/features/projects/projectsSlice.js";
import { DashboardButton } from "../../../common/DashboardButton.js";
import { Add } from "@mui/icons-material";
import { userDashboardRoute } from "../../../../utils/routes/Routes.js";
import { useGetProjectsByUserIdQuery } from "../../../../redux/features/projects/projectsApi.js";
import { FormattedMessage } from "react-intl";

export default function ProjectsPage() {
  // INIT
  const dispatch = useDispatch();
  const location = useLocation();
  const { projectId } = useParams();

  // STATE
  const [filters, setFilters] = useState({
    project_status: null,
    brand: null,
    model: null,
    vehicle_type: null,
    modified_at: null,
    created_at: null,
  });
  const [currentPage, setCurrentPage] = useState(1);

  // FUNCTIONS

  const handleFilterStateChange = (value) => {
    setFilters(value);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    dispatch(changePageNumberTickets(value));
  };

  const handleCurrentPageChange = (value) => {
    setCurrentPage(value);
  };

  // REDUX
  const pageNumber = useSelector(
    (state) => state?.project?.projectsList?.pagination?.pageNumber
  );

  const userData = useSelector(selectAuthData);

  const {
    data,
    isLoading,
    isError,
    refetch: refetchProjects,
  } = useGetProjectsByUserIdQuery(
    {
      userId: userData?.userData?.id,
      page: currentPage,
      queryFilters: filters,
    }
    // { skip: userData?.userData?.id }
  );

  // EFFECTS
  useEffect(() => {
    if (data && !isLoading && !isError) {
      dispatch(getProjects(data));
    }
  }, [data, pageNumber, isLoading, isError, dispatch]);

  useEffect(() => {
    refetchProjects();
  }, [location.pathname, dispatch, refetchProjects]);

  return (
    <Wrapper>
      {isLoading ? (
        <RowContainer center>
          <Skeleton variant="rectangular" width={300} height={50} />
        </RowContainer>
      ) : isError ? (
        <RowContainer center>
          <Typography variant="h3" component="h3">
            <div>Error</div>
          </Typography>
        </RowContainer>
      ) : projectId ? (
        <Outlet />
      ) : (
        <ColumnContainer style={{ height: "100vh" }}>
          <ColumnContainer>
            <RowContainer noGap align="center">
              <TitleContainer>
                <Typography variant="h3" component="h3">
                  <FormattedMessage id="project.title.plural" />
                </Typography>
              </TitleContainer>
              <Link to={userDashboardRoute.newProject}>
                <DashboardButton type="filled">
                  <RowContainer align="center" center minGap>
                    <Add />
                    <FormattedMessage id="button.create" />
                  </RowContainer>
                </DashboardButton>
              </Link>
            </RowContainer>
            <ProjectsList
              projects={data || []}
              paginationData={data?.pagination}
              notFilteredProjects={data?.not_filtered_project || []}
              onFilterStateChange={handleFilterStateChange}
              onProjectsPageChange={handleCurrentPageChange}
            />
          </ColumnContainer>
          <RowContainer center>
            {data?.pagination && data?.paginated_results?.length > 0 ? (
              <Pagination
                count={data?.pagination?.total_pages}
                page={data?.pagination?.active_page}
                onChange={handlePageChange}
              />
            ) : null}
          </RowContainer>
        </ColumnContainer>
      )}
    </Wrapper>
  );
}
